import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PopupActionComponent } from 'src/app/features/components/bots/bot-shared-popups/popup-action/popup-action.component';
import { MyErrorStateMatcher } from 'src/app/shared/app-classes';
import { LoggingService } from 'src/app/shared/services/Logging.service';
import { NotificationService } from 'src/app/shared/services/notification.service';


@Component({
  selector: 'app-dropdown-responses',
  templateUrl: './dropdownResponses.component.html',
  styleUrls: ['./dropdownResponses.component.scss'],
  inputs : ['actionsListResponse','built','actionSectedFormControl','createResponseBody'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownResponsesComponent {
  actionsListResponse
  built
  actionSectedFormControl
  matcher = new MyErrorStateMatcher();
  createResponseBody 
  @Output() responseSelected = new EventEmitter();


  constructor(private loggingService: LoggingService,private dialog: MatDialog,private afs : AngularFirestore , private router : Router , private snackBar : MatSnackBar,
    private notificationService: NotificationService )
  {

  }


  ngOnInit()
  {
  }

selectResponse(event: any) {
  this.loggingService.log('event selected', event);

  if (event.value === 'conv_create_new_response') {
    this.openResponseDialog();
  } else {
    this.responseSelected.emit(event.value);
  }
}

openResponseDialog() {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.data = {
    idBOT: this.createResponseBody.idBOT,
    botType: this.createResponseBody.botType,
    position: 'relative',
    isTheme: this.createResponseBody.collection,
    intention: false,
    built: false,
    show: true,
    event: false,
    builtTemplate: false,
    promptList: true,
    suggestName: ``,
    parent: ``
  };

  const dialogRef = this.dialog.open(PopupActionComponent, dialogConfig);

  dialogRef.afterClosed().subscribe((created) => {
    this.actionSectedFormControl.setValue('');
    const actionId = created?.id;
    if (!actionId || !this.createResponseBody?.idBOT) {
      return;
    }
    this.router.navigate([
      'design',
      this.createResponseBody.idBOT,
      'fulfilment-response',
      this.createResponseBody.collection,
      actionId,
    ]);
  });
}

  goToActionEdit(built, actionID)
  {
    
    this.afs.collection(`${this.createResponseBody.collection}/${this.createResponseBody.idBOT}/actions/`).doc(actionID).ref.get().then((doc:any)=>{
      if(doc.exists){

    if(built=== false){

      this.router.navigate(['design',this.createResponseBody.idBOT,'fulfilment-response',this.createResponseBody.collection,actionID]);

    }else if(built===false){
      
    }this.router.navigate(['design',this.createResponseBody.idBOT,'fulfilment-response',this.createResponseBody.collection,actionID]);
    }
    else 
      {
        this.notificationService.show('success', 'No fulfilment exist, it can be recently deleted');
      }
  })

  
  }
 

 }
